import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import Button from '../../button';
import useSendUserVerification from "../../../hooks/use-send-user-verification";
import {getAttributeValue} from "../../../lib/attribute";

interface Props {
  customer: Customer;
}

const AdminUserResendEmailVerificationForm: React.FC<Props> = ({ customer }) => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  const send = useSendUserVerification((data) => {
    const response = data.sendUserVerification;

    setMessage(response.message);
    setError(response.statusCode !== 200);
  });

  const onClick = () => {
    setMessage('');
    setError(false);
    send(customer.id);
  };

  const isEmailVerified = getAttributeValue(customer.attributes, 'isEmailVerified');
  if (isEmailVerified === "true") {
    return null;
  }

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>Resend Email Verification</h2>
      {message && <p className={error ? "error" : ""}>{message}</p>}
      <Button text="Send" onClick={onClick}/>
      {/* language=CSS */}
      <style jsx>{`
        .error {
          color: red;
        }
      `}</style>
    </form>
  );
};

export default AdminUserResendEmailVerificationForm;
